import React, { useState } from "react";
import { CloudArrowUpIcon, DocumentChartBarIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { classNames } from "src/helpers/classNames";
import DraggableFab from "../form/DraggableFab";

const DocumentRadialMenu = ({ content, setDocumentModalOpen, setActiveDocumentTab, documentModalOpen, page_type, uploadedDocuments }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandUp, setExpandUp] = useState(true);

  const hasDocuments = page_type !== "DOCUMENT" && content?.data?.groupDocuments?.length > 0;
  const isUploadEnabled = content?.data?.is_upload_enabled || uploadedDocuments?.length > 0;
  const showRadialMenu = hasDocuments && isUploadEnabled;

  const handleToggle = (e) => {
    if (!showRadialMenu) {
      if (isUploadEnabled) {
        openAction("upload");
      } else if (hasDocuments) {
        openAction("view");
      }
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    setExpandUp(rect.top > 250);
    setIsMenuOpen(!isMenuOpen);
  };

  const openAction = (tab) => {
    setActiveDocumentTab(tab);
    setDocumentModalOpen(true);
    setIsMenuOpen(false);
  };

  if (documentModalOpen || (!hasDocuments && !isUploadEnabled)) {
    return null;
  }

  return (
    <DraggableFab
      defaultRight={15}
      defaultBottom={25}
      tooltip={isMenuOpen ? "" : showRadialMenu ? "Documents & Upload" : isUploadEnabled ? "Upload" : "Documents"}
      onActivate={handleToggle}>
      <div className="relative flex items-center justify-center">
        {showRadialMenu && (
          <div
            className={classNames(
              "absolute left-1/2 flex -translate-x-1/2 flex-col items-center gap-4 transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)]",
              expandUp ? "bottom-full mb-5" : "top-full mt-5",
              isMenuOpen ? "pointer-events-auto translate-y-0 scale-100 opacity-100" : `pointer-events-none scale-50 opacity-0 ${expandUp ? "translate-y-10" : "-translate-y-10"}`,
            )}>
            <div className="flex flex-col items-center gap-1.5">
              <button
                type="button"
                onPointerDown={(e) => {
                  e.stopPropagation();
                  openAction("upload");
                }}
                className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-gray-600 shadow-xl ring-1 ring-black/5 transition-all hover:scale-110 hover:bg-highlightColor hover:text-white active:scale-95">
                <CloudArrowUpIcon className="h-5 w-5" />
              </button>
              <span className="whitespace-nowrap rounded-md bg-gray-900/80 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-white shadow-sm">Upload</span>
            </div>

            <div className="flex flex-col items-center gap-1.5">
              <button
                type="button"
                onPointerDown={(e) => {
                  e.stopPropagation();
                  openAction("view");
                }}
                className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-gray-600 shadow-xl ring-1 ring-black/5 transition-all hover:scale-110 hover:bg-highlightColor hover:text-white active:scale-95">
                <DocumentChartBarIcon className="h-5 w-5" />
              </button>
              <span className="whitespace-nowrap rounded-md bg-gray-900/80 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-white shadow-sm">Documents</span>
            </div>
          </div>
        )}

        <div
          className={classNames(
            "flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border border-white/20 shadow-2xl transition-all duration-300",
            "bg-leftNavActiveColor text-leftNavActiveTextColor",
            isMenuOpen ? "scale-90 shadow-inner brightness-90" : "hover:scale-105",
          )}>
          {isMenuOpen ? <XMarkIcon className="h-7 w-7" /> : isUploadEnabled && !hasDocuments ? <CloudArrowUpIcon className="h-7 w-7" /> : <DocumentChartBarIcon className="h-7 w-7" />}
        </div>
      </div>
    </DraggableFab>
  );
};

export default DocumentRadialMenu;
